import { getFormRequired } from '../../bereiche/dateneingabe/functions/getFormRequired';
import { getPlausiValue } from './plausibilisierung';
import { getWaermeKwh } from './getWaermeKwh';
import { IDs } from '../../helpers/IDs';
import { isFieldHidden } from '../../bereiche/dateneingabe/functions/isFieldHidden';
import { isValid as isValidAbrechnungszeitraum } from './validAbrechnungszeitraum';
import { isValid as isValidKennzahl } from './validKennzahl';
import Moment from 'moment';
import { StructureTool } from '../../core/forms/helpers/structure_tool';

const STRUCTURES: any = {};

function getStructure(modul: string, entity: string): any {
    return new StructureTool(IDs.MOD_ETOOL).getStructure(modul, entity) || {};
}

function hasRequiredValue(key: string, value: any, data: any) {
    return !(
        Object.keys(data).indexOf(key) !== -1 &&
        (typeof value === 'undefined' || value === null || value === '' || ((data[key] || {}).type === 'select' && value == 0))
    );
}

export function isValid(data: any, entity: string, dataGlobal?: any, add?: boolean): boolean {
    data = data || {};

    if (!Object.keys(data).length || !entity) {
        return false;
    }

    if (((data || {}).bemerkung || '').toString().includes('DS korrekt')) {
        return true;
    }
    const required: any[] = getFormRequired(IDs.MOD_ETOOL, entity, data, dataGlobal) || {};

    if (!STRUCTURES[entity]) {
        STRUCTURES[entity] = getStructure(IDs.MOD_ETOOL, entity);
    }
    const structure: any = STRUCTURES[entity];
    let isValid: boolean = true;

    (structure.ATTS || []).forEach((att: any) => {
        if (!(
            (typeof att.HIDDEN === 'undefined' || +att.HIDDEN === 0 || att.HIDDEN.toString().toLowerCase() === 'no')
            && typeof att.KEY !== 'undefined' && typeof att.NAME !== 'undefined'
        )) {
            return;
        }

        if (
            typeof data[att.KEY] !== 'undefined' && data[att.KEY] !== null && data[att.KEY] !== '' && !isNaN(+data[att.KEY])
            && ['double', 'int'].includes(att.TYPE.toLocaleLowerCase()) && !att.OPTS
        ) {
            data[att.KEY] = +data[att.KEY];
        }
        structure[att.KEY] = null;
    });
    data = add ? { ...structure, ...data } : data;

    Object.keys(data).forEach((key: string) => {
        const value: any = data[key];

        if (!isValid || isFieldHidden(entity, key, data, dataGlobal)) {
            return;
        } else if (!hasRequiredValue(key, value, required)) {
            if (
                (entity === IDs.ENT_BETRIEBSDATEN)
                // || (entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE && key === 'kosten' && data.kosten === null && data.verbrauch !== null)
                // || (
                //     entity === IDs.ENT_ENERGIEDATEN_WASSER && key === 'kosten_bezug' && data.kosten_bezug === null
                //     && data.fremdbezug !== null
                // )
                || (entity === IDs.ENT_CO2_SCOPE3_ABFALL &&
                    ((key === 'menge' && data['volumen_tonne'] && data['leerungen'])
                        || (key === 'volumen_tonne' && data['menge'])
                        || (key === 'leerungen' && data['menge'])
                    )
                )
                || (entity === IDs.ENT_CO2_SCOPE3_REISEN &&
                    ((key === 'entfernung' && data['firmenfahrzeug'] === 'Ja')
                        || (key === 'uebernachtungen_anzahl' && data['uebernachtungen'] === 'Nein')
                        || (key === 'uebernachtungen_anzahl' && data['parent_tid'] > 0)
                        || (key === 'uebernachtungen' && data['parent_tid'] > 0)
                        || (key === 'teilnehmer' && data['uebernachtungen'] === 'Nein')
                        || (key === 'teilnehmer' && data['parent_tid'] > 0)
                        || (key === 'teilstrecken' && data['parent_tid'] > 0)
                        || (key === 'firmenfahrzeug' && +data['parent_tid'] > 0)
                    )
                )
                || (entity === IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_TECHNIK)

            ) {
                // Ausnahme für required
                // if (entity === IDs.ENT_CO2_SCOPE3_REISEN) {
                //  console.log('SS6 MÖÖÜ - AUSN: ' + key, data);
                // }
            } else {
                if (entity === IDs.ENT_CO2_SCOPE3_REISEN) {
                    // console.log('SS6 Validierungsfehler: ' + key, data);
                }
                isValid = false;
                return;
            }
        }

        switch (entity) {
            case IDs.ENT_ANGEMIETETE_FAHRZEUGE:
                isValid = isValidValueAngemieteteFahrzeuge(key, value, data);
                break;
            case IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN:
            // no break
            case IDs.ENT_EIGENE_RAEUMLICHKEITEN:
                isValid = isValidValueRaeumlichkeiten(key, value, data);
                break;
            case IDs.ENT_ANLAGEN_EIGENSTROM_BIOMASSE:
                isValid = isValidValueEigenstromBiomasse(key, value, data);
                break;
            case IDs.ENT_ANLAGEN_EIGENSTROM_KWK:
                isValid = isValidValueEigenstromKwk(key, value, data);
                break;
            case IDs.ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK:
                isValid = isValidValueEigenstromPhotovoltaik(key, value, data);
                break;
            case IDs.ENT_ANLAGEN_EIGENSTROM_SOLARTHERMIE:
                isValid = isValidValueEigenstromSolarthermie(key, value, data);
                break;
            case IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN:
                isValid = isValidValueEigenstromWaermepumpen(key, value, data);
                break;
            case IDs.ENT_ANLAGEN_EIGENSTROM_WINDKRAFT:
                isValid = isValidValueEigenstromWindkraft(key, value, data);
                break;
            case IDs.ENT_BETRIEBSDATEN:
                isValid = isValidValueBetriebsdaten(key, value, data, dataGlobal);
                break;
            case IDs.ENT_CO2_SCOPE3_ABFALL:
                isValid = isValidValueCO2Scope3Abfall(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_ANGEMIETETE_SACHANLAGEN:
                isValid = isValidValueCO2AngemieteteSachanlagen(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_EMITTENTEN:
                isValid = isValidValueCO2Scope3Emittenten(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_FRANCHISE:
                isValid = isValidValueCO2Scope3Franchise(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
                isValid = isValidValueCO2Scope3GueterEinkauf(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL:
                isValid = isValidValueCO2Scope3GueterKapital(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_INVESTITION:
                isValid = isValidValueCO2Scope3Investition(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_PENDELN:
                isValid = isValidValueCO2Scope3Pendeln(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_PRODUKTE_LEBENSZYKLUS:
            // no break
            case IDs.ENT_CO2_SCOPE3_PRODUKTE_NUTZUNG:
            // no break
            case IDs.ENT_CO2_SCOPE3_PRODUKTE_VERARBEITUNG:
                isValid = isValidValueCO2Scope3Produkte(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_REISEN:
                isValid = isValidValueCO2Scope3Reisen(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
                isValid = isValidValueCO2Scope3TransportNachgelagert(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
                isValid = isValidValueCO2Scope3TransporttVorgelagert(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN:
                isValid = isValidValueCO2VermieteteSachanlagen(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_FAHRZEUGE:
                isValid = isValidValueCO2VermieteteSachanlagenFahrzeuge(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_RAEUMLICHKEITEN:
                isValid = isValidValueCO2VermieteteSachanlagenRaeumlichkeiten(key, value, data);
                break;
            case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_TECHNIK:
                isValid = isValidValueCO2VermieteteSachanlagenTechnik(key, value, data);
                break;
            case IDs.ENT_ENERGIEDATEN_EIGENSTROM:
                isValid = isValidValueEigenstrom(key, value, data);
                break;
            case IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE:
                isValid = isValidValueKraftstoffe(key, value, data);
                break;
            case IDs.ENT_ENERGIEDATEN_STROM:
                isValid = isValidValueStrom(key, value, data, dataGlobal);
                break;
            case IDs.ENT_ENERGIEDATEN_WAERME:
                isValid = isValidValueWaerme(key, value, data, dataGlobal);
                break;
            case IDs.ENT_VSME_BPM3:
                isValid = isValidVsmeBpm3(key, value, data, dataGlobal);
                break;
            case IDs.ENT_VSME_BPM3_SCOPE1:
                isValid = isValidVsmeBpm3Scope1(key, value, data, dataGlobal);
                break;
            case IDs.ENT_VSME_BPM3_SCOPE2:
                isValid = isValidVsmeBpm3Scope2(key, value, data, dataGlobal);
                break;
            case IDs.ENT_ENERGIEDATEN_WASSER:
                isValid = isValidValueWasser(key, value, data);
                break;
            case IDs.ENT_FAHRZEUGE:
                isValid = isValidValueFahrzeuge(key, value, data);
                break;
            case IDs.ENT_FAHRZEUGE_JAHRESWERTE:
                isValid = isValidValueFahrzeugeJahreswerte(key, value, data);
                break;
            case IDs.ENT_KLIMAGASE:
                isValid = isValidValueKlimagase(key, value, data);
                break;
            case IDs.ENT_MASCHINEN:
                isValid = isValidValueMaschinen(key, value, data);
                break;
            case IDs.ENT_MASCHINEN_JAHRESWERTE:
                isValid = isValidValueMaschinenJahreswerte(key, value, data);
                break;
            case IDs.ENT_OEL_ABRECHNUNG:
                isValid = isValidValueOelabrechnung(key, value, data, dataGlobal);
                break;
        }
    });

    return isValid;
}

function isValidAbrechnungsmodusMonat(data: any, entity: string, dataGlobal: any): boolean {
    const jahr: number = typeof data.jahr === 'number' ? +data.jahr : null;

    if (jahr !== Moment().year() && !data.parent_tid && data.abrechnungsmodus === 2 /*{2} Monatsrechnungen*/) {
        const invalidMonate: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

        ((dataGlobal || {})[entity] || []).forEach((item: any) => {
            const monat: number = item.monat || null;

            if (item.parent_tid === data.tid && item.monat >= 1 && item.monat <= 12) {
                if ([IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_WAERME].indexOf(entity) !== -1) {
                    item = { ...item, abrechnungsart: data.abrechnungsart };
                }

                if (isValid(item, entity, dataGlobal)) {
                    delete invalidMonate[monat - 1];
                }
            }
        });

        if (!!invalidMonate.reduce((a: number, b: number) => a + b, 0)) {
            return false;
        }
    }

    return true;
}

function isValidEnergiekostenanteilUmsatz(data: any, dataGlobal: any): boolean {
    dataGlobal = dataGlobal || {};
    const jahr: number = typeof data.jahr === 'number' ? +data.jahr : null;
    const standort_tid: number = typeof data.standort_tid_orig ? +data.standort_tid_orig : 0;
    const umsatz: number = typeof data.umsatz ? +data.umsatz : 0;
    const kennzahlen: any = (dataGlobal[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort_tid]
        || dataGlobal[IDs.KENNZIFFERN_BERECHNET] || {};
    const strom_kosten: number = kennzahlen[jahr] && kennzahlen[jahr].strom_kosten_gesamt ? kennzahlen[jahr].strom_kosten_gesamt : 0;
    const waerme_kosten: number = kennzahlen[jahr] && kennzahlen[jahr].kosten_waerme ? kennzahlen[jahr].kosten_waerme : 0;
    const kraftstoffe_kosten: number = kennzahlen[jahr] && kennzahlen[jahr].kraftstoffe_kosten ? kennzahlen[jahr].kraftstoffe_kosten : 0;
    const kosten_gesamt: number = strom_kosten + waerme_kosten + kraftstoffe_kosten;
    const umsatz_anteil: number = umsatz > 0 ? ((100 / umsatz) * kosten_gesamt) : 0;
    const errMax = getPlausiValue('betriebsdaten.energiekostenanteil_umsatz.error.max', 50);

    if (umsatz_anteil >= errMax) {
        return false;
    }

    return true;
}

function isValidKraftstoffpreis(data: any): boolean {
    const energietraeger: string = data.energietraeger_tid || null;
    const kosten: number = typeof data.kosten === 'number' ? +data.kosten : null;
    const verbrauch: number = typeof data.verbrauch === 'number' ? +data.verbrauch : null;
    const preis: number = kosten !== null && verbrauch !== null && verbrauch > 0 ? +(kosten / verbrauch).toFixed(3) : null;

    const isWithin = (limits: number[]): boolean => {
        if ((limits || []).length !== 2) {
            return true;
        }

        if (preis < limits[0] || preis > limits[1]) {
            return false;
        }
        return true;
    };

    if (preis !== null && preis >= 0) {
        switch (energietraeger) {
            case 'Benzin [Liter]':
                return isWithin([
                    getPlausiValue('kraftstoffpreis.benzin.error.min', 0.9),
                    getPlausiValue('kraftstoffpreis.benzin.error.max', 2.9)
                ]);
            case 'Diesel [Liter]':
                return isWithin([
                    getPlausiValue('kraftstoffpreis.diesel.error.min', 0.6),
                    getPlausiValue('kraftstoffpreis.diesel.error.max', 2.9)
                ]);
            case 'Erdgas [kg]':
                return isWithin([
                    getPlausiValue('kraftstoffpreis.erdgas.error.min', 0.7),
                    getPlausiValue('kraftstoffpreis.erdgas.error.max', 1.8)
                ]);
            case 'Ladestrom [kWh]':
                return isWithin([
                    getPlausiValue('kraftstoffpreis.ladestrom.error.min', 0.05),
                    getPlausiValue('kraftstoffpreis.ladestrom.error.max', 1.2)
                ]);
            case 'LPG [Liter]':
                return isWithin([
                    getPlausiValue('kraftstoffpreis.lpg.error.min', 0.2),
                    getPlausiValue('kraftstoffpreis.lpg.error.max', 1.45)
                ]);
            case 'Wasserstoff [kg]':
                return isWithin([
                    getPlausiValue('kraftstoffpreis.wasserstoff.error.min', 6),
                    getPlausiValue('kraftstoffpreis.wasserstoff.error.max', 15)
                ]);
        }
    }

    return true;
}

function isValidValueEigenstrom(key: string, value: any, data: any): boolean {
    let errMin, errMax;
    switch (key) {
        case 'abrechnungszeitraum_bis':
        // no break;
        case 'abrechnungszeitraum_von':
            return isValidAbrechnungszeitraum(data.jahr || null, data.abrechnungszeitraum_von || -1, data.abrechnungszeitraum_bis || -1);
        case 'einspeiseverguetung':
            errMin = getPlausiValue('eigenstrom.einspeiseverguetung.error.min', 0);
            errMax = getPlausiValue('eigenstrom.einspeiseverguetung.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            const einspeiseverguetung: number = typeof data.einspeiseverguetung === 'number' ? +data.einspeiseverguetung : null;
            const netzeinspeisung_kwh: number = typeof data.netzeinspeisung_kwh === 'number' ? +data.netzeinspeisung_kwh : null;
            const compare: number = einspeiseverguetung !== null && netzeinspeisung_kwh !== null && netzeinspeisung_kwh > 0
                ? +(einspeiseverguetung / netzeinspeisung_kwh).toFixed(2)
                : null;
            errMin = getPlausiValue('eigenstrom.einspeiseverguetung.compare.error.min', 0.01);
            errMax = getPlausiValue('eigenstrom.einspeiseverguetung.compare.error.max', 0.63);
            if (compare !== null && (compare < errMin || compare > errMax)) {
                return false;
            }
            break;
        case 'gesamtproduktion_kwh':
            errMin = getPlausiValue('eigenstrom.gesamtproduktion_kwh.error.min', 0);
            errMax = getPlausiValue('eigenstrom.gesamtproduktion_kwh.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'netzeinspeisung_kwh':
            errMin = getPlausiValue('eigenstrom.netzeinspeisung_kwh.error.min', 0);
            errMax = getPlausiValue('eigenstrom.netzeinspeisung_kwh.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            const gesamtproduktion_kwh: number = typeof data.gesamtproduktion_kwh === 'number' ? +data.gesamtproduktion_kwh : null;
            const netzeinspeisung_kwh2: number = typeof data.netzeinspeisung_kwh === 'number' ? +data.netzeinspeisung_kwh : null;

            if (gesamtproduktion_kwh !== null && netzeinspeisung_kwh2 !== null && netzeinspeisung_kwh2 > gesamtproduktion_kwh) {
                return false;
            }
            break;
    }

    return true;
}

function isValidValueAngemieteteFahrzeuge(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'entfernung': {
            const errMin: number = getPlausiValue('angemietete_fahrzeuge.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('angemietete_fahrzeuge.entfernung.error.max', 99999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

function isValidValueBetriebsdaten(key: string, value: any, data: any, dataGlobal: any): boolean {
    let errMin, errMax;
    switch (key) {
        case 'anz_mitarbeiter':
        // no break
        case 'anz_mitarbeiter_real':
            errMin = getPlausiValue('betriebsdaten.anz_mitarbeiter_real.error.min', 1);
            errMax = getPlausiValue('betriebsdaten.anz_mitarbeiter_real.error.max', 9999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'auslastung':
            errMin = getPlausiValue('betriebsdaten.auslastung.error.min', 1);
            errMax = getPlausiValue('betriebsdaten.auslastung.error.max', 150);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'beheizte_flaeche':
            errMin = getPlausiValue('betriebsdaten.beheizte_flaeche.error.min', 1);
            errMax = getPlausiValue('betriebsdaten.beheizte_flaeche.error.max', 99999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'umsatz':
            errMin = getPlausiValue('betriebsdaten.umsatz.error.min', 1);
            errMax = getPlausiValue('betriebsdaten.umsatz.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            return isValidEnergiekostenanteilUmsatz(data, dataGlobal);
    }

    return true;
}

function isValidValueCO2Scope3Abfall(key: string, value: any, data: any): boolean {
    const kategorie: string = (data || {}).kategorie || null;
    // console.log('Valid S5: ', key, value);
    switch (key) {
        case 'leerungen': {
            const errMin: number = getPlausiValue('co2scope3.abfall.leerungen.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.abfall.leerungen.error.max', 52);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.abfall.menge.error.min', 1);
            const errMax: number = getPlausiValue(
                [`co2scope3.abfall.menge.${kategorie}.error.max`, 'co2scope3.abfall.menge.error.max'], 99999999
            );
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'volumen_tonne': {
            const errMin: number = getPlausiValue('co2scope3.abfall.volumen_tonne.error.min', 1);
            const errMax: number = getPlausiValue(
                [`co2scope3.abfall.volumen_tonne.${kategorie}.error.max`, 'co2scope3.abfall.volumen_tonne.error.max'], 9999
            );
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'co2_absolut': {
            const errMin: number = getPlausiValue('co2scope3.abfall.co2_absolut.error.min', 0);
            const errMax: number = getPlausiValue(
                [`co2scope3.abfall.co2_absolut.${kategorie}.error.max`, 'co2scope3.abfall.co2_absolut.error.max'], 99999999
            );
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2AngemieteteSachanlagen(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2Scope3Emittenten(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2Scope3Franchise(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.franchise.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.franchise.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.franchise.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.franchise.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2Scope3GueterEinkauf(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.guetereinkauf.menge.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.guetereinkauf.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.guetereinkauf.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.guetereinkauf.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2Scope3GueterKapital(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'art_tid': {
            const art: string = typeof data.art_tid === 'string'
                ? data.art_tid
                : data.art_tid_name || null;
            // const kategorie_tid: number = +data.ziele_orig || +data.ziele || null;
            if (art === 'Photovoltaikanlage') {
                return false;
            }
            break;
        }
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.gueterkapital.menge.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.gueterkapital.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.gueterkapital.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.gueterkapital.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2Scope3Investition(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.investition.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.investition.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.investition.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.investition.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2Scope3Pendeln(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'arbeitstage': {
            const errMin: number = getPlausiValue('co2scope3.pendeln.arbeitstage.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.pendeln.arbeitstage.error.max', 250);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'entfernung': {
            const errMin: number = getPlausiValue('co2scope3.pendeln.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.pendeln.entfernung.error.max', 99999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('co2scope3.pendeln.kosten.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.pendeln.kosten.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'verbrauch': {
            const errMin: number = getPlausiValue('co2scope3.pendeln.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.pendeln.verbrauch.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'menge_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

function isValidValueCO2Scope3Produkte(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.produkte.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.produkte.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.produkte.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.produkte.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2Scope3Reisen(key: string, value: any, data: any): boolean {
    // console.log('SS6', data);
    switch (key) {
        case 'personen': {
            const errMin: number = getPlausiValue('co2scope3.reisen.personen.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.reisen.personen.error.max', 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'entfernung': {
            const errMin: number = getPlausiValue('co2scope3.reisen.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.reisen.entfernung.error.max', 99999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax) && data.firmenfahrzeug !== 'Ja') {
                return false;
            }
            break;
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('co2scope3.reisen.kosten.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.reisen.kosten.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'verbrauch': {
            const errMin: number = getPlausiValue('co2scope3.reisen.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.reisen.verbrauch.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'uebernachtungen_anzahl': {
            const errMin: number = getPlausiValue('co2scope3.reisen.uebernachtungen_anzahl.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.reisen.uebernachtungen_anzahl.error.max', 99);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'teilnehmer': {
            const errMin: number = getPlausiValue('co2scope3.reisen.teilnehmer.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.reisen.teilnehmer.error.max', 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'menge_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    // console.log('SS6 valid', data);

    return true;
}

function isValidValueCO2Scope3TransportNachgelagert(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'entfernung': {
            const errMin: number = getPlausiValue('co2scope3.transport.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.transport.entfernung.error.max', 25000);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.transport.menge.error.min', 0.001);
            const errMax: number = getPlausiValue('co2scope3.transport.menge.error.max', 999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('co2scope3.transport.kosten.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.transport.kosten.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'verbrauch': {
            const errMin: number = getPlausiValue('co2scope3.transport.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.transport.verbrauch.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'menge_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'personen': {
            const errMin: number = getPlausiValue('co2scope3.transport.personen.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.transport.personen.error.max', 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'uebernachtungen_anzahl': {
            const errMin: number = getPlausiValue('co2scope3.transport.uebernachtungen_anzahl.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.transport.uebernachtungen_anzahl.error.max', 99);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

function isValidValueCO2Scope3TransporttVorgelagert(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'entfernung': {
            const errMin: number = getPlausiValue('co2scope3.transport.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.transport.entfernung.error.max', 25000);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.transport.menge.error.min', 0.001);
            const errMax: number = getPlausiValue('co2scope3.transport.menge.error.max', 999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('co2scope3.transport.kosten.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.transport.kosten.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'verbrauch': {
            const errMin: number = getPlausiValue('co2scope3.transport.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.transport.verbrauch.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'menge_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'personen': {
            const errMin: number = getPlausiValue('co2scope3.transport.personen.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.transport.personen.error.max', 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

function isValidValueCO2VermieteteSachanlagen(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.menge.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.faktor.error.max', 99999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2VermieteteSachanlagenFahrzeuge(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'verbrauch': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.verbrauch.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2VermieteteSachanlagenRaeumlichkeiten(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'flaeche_gesamt': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.flaeche_gesamt.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.flaeche_gesamt.error.max', 999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'flaeche': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.flaeche.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.flaeche.error.max', 999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            const flaeche: number = typeof data.flaeche === 'number' ? +data.flaeche : null;
            const flaeche_gesamt: number = typeof data.flaeche_gesamt === 'number' ? +data.flaeche_gesamt : null;

            if (flaeche !== null && flaeche_gesamt !== null && flaeche > flaeche_gesamt) {
                return false;
            }
            break;
        }
        case 'vermietungstage': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.vermietungstage.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.vermietungstage.error.max', 366);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'nutzungszeit': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.nutzungszeit.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.nutzungszeit.error.max', 24);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueCO2VermieteteSachanlagenTechnik(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'leistung': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.leistung.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.leistung.error.max', 99999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'vermietungstage': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.vermietungstage.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.vermietungstage.error.max', 366);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'nutzungszeit': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.nutzungszeit.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.nutzungszeit.error.max', 24);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }
    return true;
}

function isValidValueEigenstromBiomasse(key: string, value: any, data: any): boolean {
    let errMin, errMax;
    switch (key) {
        case 'installations_jahr':
            errMin = getPlausiValue('eigenstrom.biomasse.installations_jahr.error.min', 1950);
            if (typeof value === 'number' && (+value < errMin || +value > Moment().year())) {
                return false;
            }
            break;
        case 'leistung':
            errMin = getPlausiValue('eigenstrom.biomasse.leistung.error.min', 1);
            errMax = getPlausiValue('eigenstrom.biomasse.leistung.error.max', 9999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
    }

    return true;
}

function isValidValueEigenstromKwk(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'leistung_elektrisch':
        // no break
        case 'leistung_thermisch':
            const errMin: number = getPlausiValue('eigenstrom.kwk.leistung_thermisch.error.min', 1);
            const errMax: number = getPlausiValue('eigenstrom.kwk.leistung_thermisch.error.max', 25000);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
    }

    return true;
}

function isValidValueEigenstromPhotovoltaik(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'leistung': {
            const errMin: number = getPlausiValue('eigenstrom.photovoltaik.leistung.error.min', 1);
            const errMax: number = getPlausiValue('eigenstrom.photovoltaik.leistung.error.max', 999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'leistung_wechselrichter': {
            const errMin: number = getPlausiValue('eigenstrom.photovoltaik.leistung_wechselrichter.error.min', 1);
            const errMax: number = getPlausiValue('eigenstrom.photovoltaik.leistung_wechselrichter.error.max', 999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'modul_anzahl': {
            const errMin: number = getPlausiValue('eigenstrom.photovoltaik.modul_anzahl.error.min', 1);
            const errMax: number = getPlausiValue('eigenstrom.photovoltaik.modul_anzahl.error.max', 9999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'modul_flaeche': {
            const errMin: number = getPlausiValue('eigenstrom.photovoltaik.modul_flaeche.error.min', 1);
            const errMax: number = getPlausiValue('eigenstrom.photovoltaik.modul_flaeche.error.max', 9999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'modul_neigung': {
            const errMin: number = getPlausiValue('eigenstrom.photovoltaik.modul_neigung.error.min', 0);
            const errMax: number = getPlausiValue('eigenstrom.photovoltaik.modul_neigung.error.max', 90);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

function isValidValueEigenstromSolarthermie(key: string, value: any, data: any): boolean {
    let errMin, errMax;
    switch (key) {
        case 'installations_jahr':
            errMin = getPlausiValue('eigenstrom.solarthermie.installations_jahr.error.min', 1950);
            if (typeof value === 'number' && (+value < errMin || +value > Moment().year())) {
                return false;
            }
            break;
        case 'kollektor_flaeche':
            errMin = getPlausiValue('eigenstrom.solarthermie.kollektor_flaeche.error.min', 1);
            errMax = getPlausiValue('eigenstrom.solarthermie.kollektor_flaeche.error.max', 999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'kollektor_neigung':
            errMin = getPlausiValue('eigenstrom.solarthermie.kollektor_neigung.error.min', 0);
            errMax = getPlausiValue('eigenstrom.solarthermie.kollektor_neigung.error.max', 90);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
    }

    return true;
}

function isValidValueEigenstromWaermepumpen(key: string, value: any, data: any): boolean {
    let errMin, errMax;
    switch (key) {
        case 'installations_jahr':
            errMin = getPlausiValue('eigenstrom.waermepumpen.installations_jahr.error.min', 1950);
            if (typeof value === 'number' && (+value < errMin || +value > Moment().year())) {
                return false;
            }
            break;
        case 'leistung':
            errMin = getPlausiValue('eigenstrom.waermepumpen.leistung.error.min', 1);
            errMax = getPlausiValue('eigenstrom.waermepumpen.leistung.error.max', 999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
    }

    return true;
}

function isValidValueEigenstromWindkraft(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'anlaufgeschwindigkeit': {
            const errMin: number = getPlausiValue('eigenstrom.windkraft.anlaufgeschwindigkeit.error.min', 1);
            const errMax: number = getPlausiValue('eigenstrom.windkraft.anlaufgeschwindigkeit.error.max', 9);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'leistung':
        // no break
        case 'leistung_wechselrichter': {
            const errMin: number = getPlausiValue('eigenstrom.windkraft.leistung_wechselrichter.error.min', 1);
            const errMax: number = getPlausiValue('eigenstrom.windkraft.leistung_wechselrichter.error.max', 9999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'mittlere_windgeschwindigkeit': {
            const errMin: number = getPlausiValue('eigenstrom.windkraft.mittlere_windgeschwindigkeit.error.min', 1);
            const errMax: number = getPlausiValue('eigenstrom.windkraft.mittlere_windgeschwindigkeit.error.max', 99);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'rotoren_durchmesser': {
            const errMin: number = getPlausiValue('eigenstrom.windkraft.rotoren_durchmesser.error.min', 1);
            const errMax: number = getPlausiValue('eigenstrom.windkraft.rotoren_durchmesser.error.max', 99);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'naben_höhe': {
            const errMin: number = getPlausiValue('eigenstrom.windkraft.naben_höhe.error.min', 1);
            const errMax: number = getPlausiValue('eigenstrom.windkraft.naben_höhe.error.max', 150);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

function isValidValueFahrzeuge(key: string, value: any, data: any): boolean {
    let errMin, errMax;
    switch (key) {
        case 'anschaffungsjahr':
            errMin = getPlausiValue('anschaffungsjahr.error.min', 1960);
            const baujahr: number = typeof (data || {}).baujahr === 'number' ? +data.baujahr : null;
            const min: number = baujahr && baujahr > errMin && +baujahr <= Moment().year() ? baujahr : errMin;
            if (typeof value === 'number' && (+value < min || +value > Moment().year())) {
                return false;
            }
            break;
        case 'baujahr':
            errMin = getPlausiValue('fahrzeugbaujahr.error.min', 1960);
            if (typeof value === 'number' && (+value < errMin || +value > Moment().year())) {
                return false;
            }
            break;
        case 'jahr_status':
            const status: number = typeof (data || {}).status === 'number' ? +data.status : null;
            const anschaffungsjahr: number = typeof (data || {}).anschaffungsjahr === 'number' ? +data.anschaffungsjahr : null;
            if (status === 2 && typeof value === 'number' && (+value < anschaffungsjahr || +value > Moment().year())) {
                return false;
            }
            break;
        case 'laufleistung':
            errMin = getPlausiValue('fahrzeugJahreslaufleistung.error.min', 0);
            errMax = getPlausiValue('fahrzeugJahreslaufleistung.error.max', 99999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'leistung':
            errMin = getPlausiValue('fahrzeugleistung.error.min', 0);
            errMax = getPlausiValue('fahrzeugleistung.error.max', 999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
    }

    return true;
}

function isValidValueFahrzeugeJahreswerte(key: string, value: any, data: any): boolean {
    let errMin, errMax;
    switch (key) {
        case 'laufleistung':
            errMin = getPlausiValue('fahrzeugeJahreswerte.laufleistung.error.min', 1);
            errMax = getPlausiValue('fahrzeugeJahreswerte.laufleistung.error.max', 99000);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
    }

    return true;
}

function isValidValueKlimagase(key: string, value: any, data: any): boolean {
    let errMin, errMax;
    switch (key) {
        case 'menge':
            errMin = getPlausiValue('klimagasmenge.error.min', 0);
            errMax = getPlausiValue('klimagasmenge.error.max', 9999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
    }

    return true;
}

function isValidValueKraftstoffe(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'abrechnungszeitraum_bis':
        // no break;
        case 'abrechnungszeitraum_von':
            return isValidAbrechnungszeitraum(data.jahr || null, data.abrechnungszeitraum_von || -1, data.abrechnungszeitraum_bis || -1);
        case 'kosten': {
            const errMin: number = getPlausiValue('kraftstoffe.kosten.error.min', 0);
            const errMax: number = getPlausiValue('kraftstoffe.kosten.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            return isValidKraftstoffpreis(data);
        }
        case 'verbrauch': {
            const errMin: number = getPlausiValue('kraftstoffe.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('kraftstoffe.verbrauch.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            return isValidKraftstoffpreis(data);
        }
        case 'laufleistung': {
            const errMin: number = getPlausiValue('kraftstoffJahreslaufleistung.error.min', 0);
            const errMax: number = getPlausiValue('kraftstoffJahreslaufleistung.error.max', 99999);
            const fahrzeug_tid: number = typeof (data || {}).fahrzeug_tid_orig === 'number' ? +data.fahrzeug_tid_orig : null;
            if (fahrzeug_tid !== null && fahrzeug_tid > 0 && typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
        }
    }

    return true;
}

function isValidValueMaschinen(key: string, value: any, data: any): boolean {
    let errMin, errMax;
    switch (key) {
        case 'abwaerme':
            errMin = getPlausiValue('abwaermetemperatur.error.min', 20);
            errMax = getPlausiValue('abwaermetemperatur.error.max', 9999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'auslastungsfaktor':
            errMin = getPlausiValue('maschinen.auslastungsfaktor.error.min', 1);
            errMax = getPlausiValue('maschinen.auslastungsfaktor.error.max', 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'baujahr':
            errMin = getPlausiValue('maschinenbaujahr.error.min', 1900);
            if (typeof value === 'number' && (+value < errMin || +value > Moment().year())) {
                return false;
            }
            break;
        case 'betriebszeit_h_tag':
            errMin = getPlausiValue('maschinen.betriebszeit_h_tag.error.min', 1);
            errMax = getPlausiValue('maschinen.betriebszeit_h_tag.error.max', 24);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'betriebszeit_tage_jahr':
            errMin = getPlausiValue('maschinen.betriebszeit_tage_jahr.error.min', 1);
            errMax = getPlausiValue('maschinen.betriebszeit_tage_jahr.error.max', 366);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'jahr_status':
            const status: number = typeof (data || {}).status === 'number' ? +data.status : null;
            const baujahr: number = typeof (data || {}).baujahr === 'number' ? +data.baujahr : null;
            if (status === 2 && typeof value === 'number' && (+value < baujahr || +value > Moment().year())) {
                return false;
            }
            break;
        case 'leistung':
            errMin = getPlausiValue('anschlussleistung.error.min', 0.01);
            errMax = getPlausiValue('anschlussleistung.error.max', 9999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'messwert_unterzaehler':
            errMin = getPlausiValue('maschinen.messwert_unterzaehler.error.min', 0);
            errMax = getPlausiValue('maschinen.messwert_unterzaehler.error.max', 999999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
    }

    return true;
}

function isValidValueMaschinenJahreswerte(key: string, value: any, data: any): boolean {
    let errMin, errMax;
    switch (key) {
        case 'auslastungsfaktor':
            errMin = getPlausiValue('maschinen.auslastungsfaktor.error.min', 1);
            errMax = getPlausiValue('maschinen.auslastungsfaktor.error.max', 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'betriebszeit_h_tag':
            errMin = getPlausiValue('maschinen.betriebszeit_h_tag.error.min', 1);
            errMax = getPlausiValue('maschinen.betriebszeit_h_tag.error.max', 24);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'betriebszeit_tage_jahr':
            errMin = getPlausiValue('maschinen.betriebszeit_tage_jahr.error.min', 1);
            errMax = getPlausiValue('maschinen.betriebszeit_tage_jahr.error.max', 366);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        case 'messwert_unterzaehler':
            errMin = getPlausiValue('maschinen.messwert_unterzaehler.error.min', 0);
            errMax = getPlausiValue('maschinen.messwert_unterzaehler.error.max', 999999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
    }

    return true;
}

function isValidValueOelabrechnung(key: string, value: any, data: any, dataGlobal: any): boolean {
    const bundle: any = (dataGlobal || {})[`${IDs.ENT_OEL_ABRECHNUNG}_bundle`] || {};
    data = data;
    data.energietraeger_tid_name = ((bundle.energietraeger_tid || [])
        .find((item: any) => item.tid === data.energietraeger_tid) || {}).name || null;
    data.einheit_tid_name = ((bundle.einheit_tid || [])
        .find((item: any) => item.tid === data.einheit_tid) || {}).name || null;

    switch (key) {
        case 'fuellmenge': {
            const errMin: number = getPlausiValue('oelabrechnung.fuellmenge.error.min', 1);
            const errMax: number = getPlausiValue('oelabrechnung.fuellmenge.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            return isValidWaermepreis(data, dataGlobal);
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('oelabrechnung.kosten.error.min', 1);
            const errMax: number = getPlausiValue('oelabrechnung.kosten.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            return isValidWaermepreis(data, dataGlobal);
        }
    }

    return true;
}

function isValidValueRaeumlichkeiten(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'nutzungstage': {
            const errMin: number = getPlausiValue('raeumlichkeiten.nutzungstage.error.min', 1);
            const errMax: number = getPlausiValue('raeumlichkeiten.nutzungstage.error.max', 366);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'nutzungszeit': {
            const errMin: number = getPlausiValue('raeumlichkeiten.nutzungszeit.error.min', 1);
            const errMax: number = getPlausiValue('raeumlichkeiten.nutzungszeit.error.max', 24);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'flaeche': {
            const errMin: number = getPlausiValue('raeumlichkeiten.flaeche.error.min', 1);
            const errMax: number = getPlausiValue('raeumlichkeiten.flaeche.error.max', 99999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'flaeche_gebaeude': {
            let errMin: number = getPlausiValue('raeumlichkeiten.flaeche_gebaeude.error.min', 1);
            let errMax: number = getPlausiValue('raeumlichkeiten.flaeche_gebaeude.error.max', 99999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            const flaeche: number = typeof data.flaeche === 'number' ? +data.flaeche : null;
            const flaeche_gebaeude: number = typeof data.flaeche_gebaeude === 'number' ? +data.flaeche_gebaeude : null;

            if (flaeche !== null && flaeche_gebaeude !== null && flaeche_gebaeude < flaeche) {
                return false;
            }
            break;
        }
        case 'faktor_kaelte': {
            const errMin: number = getPlausiValue('raeumlichkeiten.faktor_kaelte.error.min', 0);
            const errMax: number = getPlausiValue('raeumlichkeiten.faktor_kaelte.error.max', 1000);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'entfernung': {
            const errMin: number = getPlausiValue('angemietete_fahrzeuge.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('angemietete_fahrzeuge.entfernung.error.max', 99999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

function isValidValueStrom(key: string, value: any, data: any, dataGlobal: any): boolean {
    switch (key) {
        case 'abrechnungsmodus':
            return isValidAbrechnungsmodusMonat(data, IDs.ENT_ENERGIEDATEN_STROM, dataGlobal);
        case 'abrechnungszeitraum_bis':
        // no break;
        case 'abrechnungszeitraum_von':
            return isValidAbrechnungszeitraum(data.jahr || null, data.abrechnungszeitraum_von || -1, data.abrechnungszeitraum_bis || -1);
        case 'co2_emissionen': {
            const errMin: number = getPlausiValue('strom.co2_emissionen.error.min', 0);
            const errMax: number = getPlausiValue('strom.co2_emissionen.error.max', 999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'kosten_netto': {
            const errMin: number = getPlausiValue('strom.kosten_netto.error.min', 0);
            const errMax: number = getPlausiValue('strom.kosten_netto.error.max', 999999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            const abrechnungsart: number = typeof (data || {}).abrechnungsart === 'number' ? +data.abrechnungsart : null; // {1} Reguläre Abrechnung, {2} Einzelabrechnung, {3} Erste Abrechnung, {4} Letzte Abrechnung
            const kosten: number = typeof data.kosten_netto === 'number' ? +data.kosten_netto : null;
            const verbrauch: number = typeof data.verbrauch_kwh === 'number' ? +data.verbrauch_kwh : null;
            const preis: number = kosten !== null && verbrauch !== null && verbrauch > 0 ? +(kosten / verbrauch).toFixed(2) : null;
            const errMinPreis: number = getPlausiValue('strompreis.error.min', 0.05);
            const errMaxPreis: number = getPlausiValue('strompreis.error.max', 1.2);

            if (abrechnungsart !== 2 && preis !== null && (preis < errMinPreis || preis > errMaxPreis)) {
                return false;
            }

            // if (!isValidKennzahl('verbrauch_strom', data, dataGlobal)) {
            //     return false;
            // }
            break;
        }
        case 'verbrauch_kwh': {
            const errMin: number = getPlausiValue('strom.verbrauch_kwh.error.min', 0);
            const errMax: number = getPlausiValue('strom.verbrauch_kwh.error.max', 999999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            const abrechnungsart: number = typeof (data || {}).abrechnungsart === 'number' ? +data.abrechnungsart : null; // {1} Reguläre Abrechnung, {2} Einzelabrechnung, {3} Erste Abrechnung, {4} Letzte Abrechnung
            const kosten: number = typeof data.kosten_netto === 'number' ? +data.kosten_netto : null;
            const verbrauch: number = typeof data.verbrauch_kwh === 'number' ? +data.verbrauch_kwh : null;
            const preis: number = kosten !== null && verbrauch !== null && verbrauch > 0 ? +(kosten / verbrauch).toFixed(2) : null;
            const errMinPreis: number = getPlausiValue('strompreis.error.min', 0.05);
            const errMaxPreis: number = getPlausiValue('strompreis.error.max', 1.2);

            if (abrechnungsart !== 2 && preis !== null && (preis < errMinPreis || preis > errMaxPreis)) {
                return false;
            }

            // if (!isValidKennzahl('verbrauch_strom', data, dataGlobal)) {
            //     return false;
            // }
            break;
        }
        case 'spitzenlast': {
            const errMin: number = getPlausiValue('stromspitzenlast.error.min', 0);
            const errMax: number = getPlausiValue('stromspitzenlast.error.max', 9999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

export function isValidVsmeBpm3(key: string, value: any, data: any, dataGlobal: any): boolean {
    if (key !== 'jahr') {
        return true;
    }
    data = data || {};
    const entities: string[] = [IDs.ENT_VSME_BPM3_SCOPE1, IDs.ENT_VSME_BPM3_SCOPE2];
    const validValues: number = entities.reduce((sum: number, entity: string) =>
        sum + +((dataGlobal || {})[entity] || [])
            .filter((item: any) => item.jahr === data.jahr)
            .some((item: any) => isValid(item, entity, dataGlobal)), 0
    );

    if ((data.ziele_orig || data.ziele) === 1 && validValues !== entities.length) {
        return false;
    }

    return true;
}

export function isValidVsmeBpm3Scope1(key: string, value: any, data: any, dataGlobal: any): boolean {
    const prefix: string = 'vsme.bpm3.scope1';
    switch (key) {
        case 'basisjahr': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 2010);
            if (typeof value === 'number' && (+value < errMin || +value > Moment().year())) {
                return false;
            }
            break;
        }
        case 'emissionseinsparung_kurzfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'emissionseinsparung_mittelfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'emissionseinsparung_langfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

export function isValidVsmeBpm3Scope2(key: string, value: any, data: any, dataGlobal: any): boolean {
    const prefix: string = 'vsme.bpm3.scope2';
    switch (key) {
        case 'basisjahr': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 2010);
            if (typeof value === 'number' && (+value < errMin || +value > Moment().year())) {
                return false;
            }
            break;
        }
        case 'emissionseinsparung_kurzfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'emissionseinsparung_mittelfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'emissionseinsparung_langfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

function isValidValueWaerme(key: string, value: any, data: any, dataGlobal: any): boolean {
    switch (key) {
        case 'abrechnungsmodus':
            return isValidAbrechnungsmodusMonat(data, IDs.ENT_ENERGIEDATEN_WAERME, dataGlobal);
        case 'abrechnungszeitraum_bis':
        // no break;
        case 'abrechnungszeitraum_von':
            return isValidAbrechnungszeitraum(data.jahr || null, data.abrechnungszeitraum_von || -1, data.abrechnungszeitraum_bis || -1);
        case 'co2_emissionen': {
            let errMin: number, errMax: number;
            if (data && data.einheit_tid_orig === 7 /* MWh */) {
                errMin = getPlausiValue('waerme.co2_emissionen_mwh.error.min', 0);
                errMax = getPlausiValue('waerme.co2_emissionen_mwh.error.max', 999999);
            } else {
                errMin = getPlausiValue('waerme.co2_emissionen.error.min', 0);
                errMax = getPlausiValue('waerme.co2_emissionen.error.max', 999);
            }
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('waerme.kosten.error.min', 0);
            const errMax: number = getPlausiValue('waerme.kosten.error.max', 999999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            return isValidWaermepreis(data, dataGlobal);
        }
        case 'verbrauch': {
            const convertValue = (value: number): number => {
                const einheit: string = typeof data.einheit_tid === 'string'
                    ? data.einheit_tid
                    : data.einheit_tid_name || null;
                return einheit === 'MWh' && typeof value === 'number' ? parseInt((value / 1000).toString(), 10) : value;
            };
            const errMin: number = convertValue(getPlausiValue('waerme.verbrauch.error.min', 0));
            const errMax: number = convertValue(getPlausiValue('waerme.verbrauch.error.max', 999999999));
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            return isValidWaermepreis(data, dataGlobal);
        }
        case 'prozess_waerme': {
            const errMin: number = getPlausiValue('waerme.prozess_waerme.error.min', 0);
            const errMax: number = getPlausiValue('waerme.prozess_waerme.error.max', 100);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

function isValidValueWasser(key: string, value: any, data: any): boolean {
    switch (key) {
        case 'abrechnungszeitraum_bis':
        // no break;
        case 'abrechnungszeitraum_von':
            return isValidAbrechnungszeitraum(data.jahr || null, data.abrechnungszeitraum_von || -1, data.abrechnungszeitraum_bis || -1);
        case 'fremdbezug': {
            const einheit: string = data.einheit_tid || null;
            const errMin: number = getPlausiValue('fremdbezug.m3.error.min', 0);
            const errMax: number = getPlausiValue('fremdbezug.m3.error.max', 9999);
            const err2Min: number = getPlausiValue('fremdbezug.error.min', 0);
            const err2Max: number = getPlausiValue('fremdbezug.error.max', 9999999);
            if (einheit === 'm³' && typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            } else if (typeof value === 'number' && (+value < err2Min || +value > err2Max)) {
                return false;
            }
            break;
        }
        case 'regen_brunnennutzung': {
            const einheit_regen: string = data.einheit_regen_tid || null;
            const errMin: number = getPlausiValue('regenBrunnennutzung.m3.error.min', 0);
            const errMax: number = getPlausiValue('regenBrunnennutzung.m3.error.max', 9999);
            const err2Min: number = getPlausiValue('regenBrunnennutzung.error.min', 0);
            const err2Max: number = getPlausiValue('regenBrunnennutzung.error.max', 9999999);
            if (einheit_regen === 'm³' && typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            } else if (typeof value === 'number' && (+value < err2Min || +value > err2Max)) {
                return false;
            }
            break;
        }
        case 'kosten_abwasser': {
            const errMin: number = getPlausiValue('wasser.kosten_abwasser.error.min', 0);
            const errMax: number = getPlausiValue('wasser.kosten_abwasser.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'kosten_bezug': {
            const errMin: number = getPlausiValue('wasser.kosten_bezug.error.min', 0);
            const errMax: number = getPlausiValue('wasser.kosten_bezug.error.max', 9999999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
        case 'rueckerstattung': {
            const errMin: number = getPlausiValue('wasser.rueckerstattung.error.min', 0);
            const errMax: number = getPlausiValue('wasser.rueckerstattung.error.max', 99999);
            if (typeof value === 'number' && (+value < errMin || +value > errMax)) {
                return false;
            }
            break;
        }
    }

    return true;
}

function isValidWaermepreis(data: any, dataGlobal: any): boolean {
    const abrechnungsart: number = typeof data.abrechnungsart === 'number' ? +data.abrechnungsart : null; // {1} Reguläre Abrechnung, {2} Einzelabrechnung, {3} Erste Abrechnung, {4} Letzte Abrechnung
    const energietraeger: string = typeof data.energietraeger_tid === 'string'
        ? data.energietraeger_tid
        : data.energietraeger_tid_name || null;
    const einheit: string = typeof data.einheit_tid === 'string'
        ? data.einheit_tid
        : data.einheit_tid_name || null;
    const jahr: number = typeof data.jahr === 'number' ? +data.jahr : null;
    const convertValue = (value: number): number => getWaermeKwh(energietraeger, value, einheit, jahr, dataGlobal);
    const kosten: number = typeof data.kosten === 'number' ? +data.kosten : null;
    const verbrauch: number = typeof data.verbrauch === 'number' // verbrauch, fuellmenge
        ? convertValue(+data.verbrauch)
        : (typeof data.fuellmenge === 'number' ? convertValue(+data.fuellmenge) : null);
    const preis: number = kosten !== null && verbrauch !== null && verbrauch > 0 ? +(kosten / verbrauch).toFixed(3) : null;

    const isWithin = (limits: number[], param: string): boolean => {
        if ((limits || []).length !== 2 || !param) {
            return true;
        }
        limits[0] = getPlausiValue(`waermepreis.${param}.error.min`, limits[0]);
        limits[1] = getPlausiValue(`waermepreis.${param}.error.max`, limits[1]);

        if (preis < limits[0] || preis > limits[1]) {
            return false;
        }
        return true;
    };

    if (abrechnungsart !== 2 && preis !== null && preis >= 0) {
        switch (energietraeger) {
            case 'Biogas': break;
                return ['kg', 'kWh', 'm³'].indexOf(einheit) !== -1 ? isWithin([-1, -1], 'biogas') : true;
            case 'Biomasse - Brennholz': break;
                return ['kWh', 'Rm (Raummeter)'].indexOf(einheit) !== -1 ? isWithin([-1, -1], 'bio_brennholz') : true;
            case 'Biomasse - Hackschnitzel': break;
                return ['kWh', 'Srm (Schüttraummeter)'].indexOf(einheit) !== -1 ? isWithin([-1, -1], 'bio_hackschnitzel') : true;
            case 'Biomasse - Pellets': break;
                return ['kg', 'kWh'].indexOf(einheit) !== -1 ? isWithin([-1, -1], 'bio_holzpellets') : true;
            case 'Erdgas':
                return ['kWh', 'm³'].indexOf(einheit) !== -1 ? isWithin([0.02, 0.4], 'erdgas') : true;
            case 'Fernkälte': break;
                return einheit === 'kWh' ? isWithin([-1, -1, -1, -1], 'fernkaelte') : true;
            case 'Fernwärme':
                return ['kWh', 'MWh'].indexOf(einheit) !== -1 ? isWithin([0.02, 0.35], 'fernwaerme') : true;
            case 'Flüssiggas':
                return ['kg', 'kWh', 'Liter'].indexOf(einheit) !== -1 ? isWithin([0.15, 1.5], 'fluessiggas') : true;
            case 'Heizöl':
                return ['kWh', 'Liter'].indexOf(einheit) !== -1 ? isWithin([0.2, 2], 'heizoel') : true;
            case 'Kohle - Braunkohle': break;
                return ['kg', 'kWh'].indexOf(einheit) !== -1 ? isWithin([-1, -1], 'braunkohle') : true;
            case 'Kohle - Steinkohle': break;
                return ['kg', 'kWh'].indexOf(einheit) !== -1 ? isWithin([-1, -1], 'steinkohle') : true;
            case 'Strom':
                return einheit === 'kWh' ? isWithin([0.05, 1.2], 'strom') : true;
        }
    }

    return true;
}
